// src/pages/Contact.js
import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaFacebook, FaInstagram, FaTiktok } from 'react-icons/fa';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';
import emailjs from '@emailjs/browser';

const countryCodes = [
  { name: "United States", code: "+1", iso: "US" },
  { name: "Ghana", code: "+233", iso: "GH" },
  { name: "United Kingdom", code: "+44", iso: "GB" },
  { name: "Nigeria", code: "+234", iso: "NG" }
];

const Contact = () => {
  const location = useLocation();
  const [selectedCountry, setSelectedCountry] = useState("+1");
  const [formData, setFormData] = useState({
      fullName: '', email: '', phone: '', subject: 'General Question', message: ''
  });
  const [status, setStatus] = useState('');

  useEffect(() => {
    if (location.state && location.state.selectedSubject) {
        setFormData(prev => ({ ...prev, subject: location.state.selectedSubject }));
    }
  }, [location.state]);

  const handleChange = (e) => setFormData({...formData, [e.target.name]: e.target.value});

  const handleSubmit = async (e) => {
      e.preventDefault();
      setStatus('Sending...');
      const fullPhone = `${selectedCountry} ${formData.phone}`;

      try {
          // 1. Save to Firebase
          await addDoc(collection(db, "messages"), {
              ...formData,
              fullPhone: fullPhone,
              createdAt: new Date(),
              read: false
          });
          
          // 2. Send Email via EmailJS
          // Updated matching keys for your template
          const emailParams = {
              type: "Contact Form Message",
              fullName: formData.fullName,
              email: formData.email,
              phone: fullPhone,
              subject: formData.subject,
              message: formData.message,
              offerAmount: "N/A",
              carName: "N/A",
              itemName: "N/A",
              annualIncome: "N/A"
          };

          await emailjs.send(
              'service_nkj2h8t', 
              'template_lih1iy7', 
              emailParams, 
              'MpvXLl-LNdIwPQyBf'
          );

          setStatus('Message Sent Successfully!');
          setFormData({ fullName: '', email: '', phone: '', subject: 'General Question', message: '' });
      } catch (error) {
          console.error(error);
          setStatus('Failed to send message. Please try again.');
      }
  };

  // Scroll Reveal Hook
  const useScrollReveal = (threshold = 0.1) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => { if (entry.isIntersecting) { setIsVisible(true); observer.disconnect(); } },
        { threshold }
      );
      if (ref.current) observer.observe(ref.current);
      return () => observer.disconnect();
    }, [threshold]);
    return [ref, isVisible];
  };

  const [headerRef, headerVisible] = useScrollReveal();
  const [leftRef, leftVisible] = useScrollReveal();
  const [rightRef, rightVisible] = useScrollReveal();

  const getStyle = (isVisible, transformVal, delay = '0s') => ({
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translate(0, 0)' : transformVal,
    transition: `opacity 0.8s ease ${delay}, transform 0.8s ease ${delay}`,
  });

  return (
    <div className="container" style={{ padding: '60px 20px', overflow: 'hidden' }}>
      
      <div ref={headerRef} style={getStyle(headerVisible, 'translateY(-30px)')}>
        <h1 style={{ textAlign: 'center', marginBottom: '40px' }}>Contact Cremlora LLC</h1>
      </div>
      
      <div className="grid-2">
        <div ref={leftRef} style={{...getStyle(leftVisible, 'translateX(-50px)', '0.2s'), background: 'white', padding: '30px', borderRadius: '8px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)'}}>
            <h3>Send Us a Message</h3>
            {status && <p style={{color: status.includes('Success') ? 'green' : 'red', marginBottom: '10px'}}>{status}</p>}
            
            <form onSubmit={handleSubmit}>
                <input type="text" name="fullName" placeholder="Full Name" required value={formData.fullName} onChange={handleChange} />
                <input type="email" name="email" placeholder="Email Address" required value={formData.email} onChange={handleChange} />
                
                <div style={{ display: 'flex', gap: '10px' }}>
                  <select style={{ flex: '0 0 110px' }} value={selectedCountry} onChange={(e) => setSelectedCountry(e.target.value)}>
                    {countryCodes.map((country, index) => (
                      <option key={index} value={country.code}>{country.iso} ({country.code})</option>
                    ))}
                  </select>
                  <input type="tel" name="phone" placeholder="Phone Number" required style={{ flex: '1' }} value={formData.phone} onChange={handleChange} />
                </div>

                <select name="subject" value={formData.subject} onChange={handleChange}>
                    <option value="I'm interested in buying">I'm interested in buying</option>
                    <option value="I want to sell my car">I want to sell my car</option>
                    <option value="Service/Parts">Service/Parts</option>
                    <option value="General Question">General Question</option>
                </select>
                <textarea name="message" rows="5" placeholder="How can we help you?" required value={formData.message} onChange={handleChange}></textarea>
                
                <button type="submit" className="btn btn-primary" style={{width: '100%'}}>Send Message</button>
            </form>
        </div>

        <div ref={rightRef} style={getStyle(rightVisible, 'translateX(50px)', '0.4s')}>
            <h3>Visit Our Showroom</h3>
            <p style={{marginBottom: '20px'}}>Stop by to test drive your dream car today.</p>
            <div style={{marginBottom: '20px'}}>
                <div style={{display:'flex', alignItems:'center', gap:'10px', marginBottom:'10px'}}>
                    <FaMapMarkerAlt color="var(--accent-blue)"/> <span>2785 terrace grove drive Conroe, TX 77304 USA</span>
                </div>
                <div style={{display:'flex', alignItems:'center', gap:'10px', marginBottom:'10px'}}>
                    <FaPhone color="var(--accent-blue)"/> <span>(850) 736-4448</span>
                </div>
                <div style={{display:'flex', alignItems:'center', gap:'10px', marginBottom:'10px'}}>
                    <FaEnvelope color="var(--accent-blue)"/> <span>sales@cremlorallc.com</span>
                </div>
            </div>
             <h4 style={{display:'flex', alignItems:'center', gap:'10px'}}><FaClock color="var(--primary-dark)" /> Business Hours</h4>
            <ul style={{listStyle: 'none', margin: '10px 0 20px 0'}}>
                <li>Mon - Fri: 9:00 AM - 8:00 PM</li>
                <li>Saturday: 9:00 AM - 6:00 PM</li>
                <li>Sunday: Closed</li>
            </ul>

            <h4>Follow Us</h4>
            <div style={{display: 'flex', gap: '15px', fontSize: '1.5rem', color: 'var(--primary-dark)'}}>
                <div style={{cursor: 'pointer', transition: 'transform 0.3s'}} onMouseOver={e=>e.currentTarget.style.transform='scale(1.2)'} onMouseOut={e=>e.currentTarget.style.transform='scale(1)'}>
                  <FaFacebook />
                </div>
                <div style={{cursor: 'pointer', transition: 'transform 0.3s'}} onMouseOver={e=>e.currentTarget.style.transform='scale(1.2)'} onMouseOut={e=>e.currentTarget.style.transform='scale(1)'}>
                  <FaInstagram />
                </div>
                <div style={{cursor: 'pointer', transition: 'transform 0.3s'}} onMouseOver={e=>e.currentTarget.style.transform='scale(1.2)'} onMouseOut={e=>e.currentTarget.style.transform='scale(1)'}>
                  <FaTiktok />
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;